import { useTranslation } from 'react-i18next';
import type { StaffOnlyFormData } from './StaffOnlyFilterForm';
import type { UseFormRegister } from 'react-hook-form';

interface StaffOnlySearchFormProps {
  register: UseFormRegister<StaffOnlyFormData>;
  isDisabled?: boolean;
}

export const StaffOnlySearchForm = ({
  register,
  isDisabled = false,
}: StaffOnlySearchFormProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={`e__fields e-search__row e-search__row--double e-search__row--lockable ${isDisabled ? 'is-disabled' : ''}`}
    >
      <div className="e__field e-search__field">
        <label className="e-search__label" htmlFor="search-name">
          {t('staffOnly.search.customerNameLabel')}
        </label>
        <input
          className="e__input e-search__input"
          type="text"
          id="search-name"
          placeholder={t('staffOnly.search.customerName')}
          {...register('customerNameSearch')}
        />
      </div>
      <div className="e__field e-search__field">
        <label className="e-search__label" htmlFor="search-reservation-id">
          {t('staffOnly.search.reservationNumberLabel')}
        </label>
        <input
          className="e__input e-search__input"
          type="text"
          id="search-reservation-id"
          placeholder={t('staffOnly.search.reservationNumber')}
          {...register('reservationNumberSearch')}
        />
      </div>
    </div>
  );
};
